import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "../node_modules/fomantic-ui/dist/semantic.min.css";
import "vue-swatches/dist/vue-swatches.css";
// import "../node_modules/fomantic-ui/dist/semantic.materia.min.css";
// import "../node_modules/fomantic-ui/dist/semantic.yeti.min.css";
// import "../node_modules/fomantic-ui/dist/semantic.material.min.css";
// import "../node_modules/fomantic-ui/dist/semantic.twitter.min.css";
// import "../node_modules/fomantic-ui/dist/semantic.amazon.min.css";
// import "../node_modules/fomantic-ui/dist/semantic.cerulean.min.css";
// import "../node_modules/fomantic-ui/dist/semantic.minty.min.css";
import jQuery from "jquery";
import VueSession from "vue-session";
import axios from "axios";
import VueAxios from "vue-axios";
import i18n from "./i18n";
import VueAlertify from "vue-alertify";
import VueImg from "v-img";
import utils from "./utils";
import VueMask from "v-mask";
import responsive from "vue-responsive";

var VueTruncate = require("vue-truncate-filter");

global.jQuery = jQuery;
require("fomantic-ui");
// console.log(fomantic);
jQuery.fn.api.settings.api = {
  "search event": `${utils.api_host}/calendar/search/{query}/`,
  "search user": `${utils.api_host}/user/search/{query}`,
  "search professor": `${utils.api_host}/professor/professor/search/{query}`,
  "search account": `${utils.api_host}/account/search/{query}`,
  "search student": `${utils.api_host}/student/search/{query}`,
  "search role": `${utils.api_host}/user_role/search/{query}`,
  "search customer": `${utils.api_host}/customer/search/{query}`,
  "search pet": `${utils.api_host}/pet/search/{query}`,
  "search product": `${utils.api_host}/product/search/{query}`,
  "worklist url": `${utils.api_host}/ngine_workspace/worklist/do-get-list`,
  "inventory overview products url": `${utils.api_host}/inventory_overview/do-get-products`,
  "pos products url": `${utils.api_host}/point_of_sale/do-get-products`,
  "product products url": `${utils.api_host}/product/do-get-products`,
  "student url": `${utils.api_host}/student/do-get-list`,
  "user url": `${utils.api_host}/user/do-get-list`,
  "robocredit url": `${utils.api_host}/robocredit/robocredit/do-get-list`,
  "robocredit existing customer url": `${utils.api_host}/robocredit/robocredit/do-get-existing-customer-list`,
  "robocredit catalog banned occupation url": `${utils.api_host}/robocredit/catalog/do-get-banned-occupation-list`,
  "robocredit catalog banned enterprise name url": `${utils.api_host}/robocredit/catalog/do-get-banned-enterprise-list`,
  "customer url": `${utils.api_host}/customer/do-get-list`,
  "quotation url": `${utils.api_host}/quotation/do-get-list`,
  "account url": `${utils.api_host}/account/do-get-list`,
  "transaction url": `${utils.api_host}/account_transaction/do-get-list`,
  "user portal users url": `${utils.api_host}/student_portal/users/do-get-list`,
  "search course": `${utils.api_host}/course/course/search/{query}`,
  "search product category": `${utils.api_host}/product_category/search/{query}`,
  "search survey template": `${utils.api_host}/survey/template/search/{query}`,
  "course url": `${utils.api_host}/course/course/do-get-list`,
  "pensum url": `${utils.api_host}/pensum/do-get-list`,
  "course assignation seasons url": `${utils.api_host}/course/assignation/do-get-season-list`,
  "professor url": `${utils.api_host}/professor/professor/do-get-list`,
  "outbox url": `${utils.api_host}/outbox/template/do-get-list`,
  "outbox message url": `${utils.api_host}/outbox/message/do-get-list`,
  "shortio url": `${utils.api_host}/shortio/link/do-get-list`,
  "visalink url": `${utils.api_host}/visalink/link/do-get-list`,
  "visalink generator url": `${utils.api_host}/visalink_generator/link/do-get-list`,
  "visalink generator bulk url": `${utils.api_host}/visalink_generator/bulk/do-get-list`,
  "survey template url": `${utils.api_host}/survey/template/do-get-list`,
  "serbipagos transactions url": `${utils.api_host}/serbipagos/transaction/do-get-list`,
  "feedback 360 survey url": `${utils.api_host}/feedback_360/survey/do-get-list`,
  "feedback 360 survey user url": `${utils.api_host}/feedback_360/user_survey/do-get-list`,
  "teacher rating url": `${utils.api_host}/teacher_rating/rating/do-get-own-list`,
  "onfido url": `${utils.api_host}/onfido_connect/do-get-list`,
  "staff rating template url": `${utils.api_host}/staff_rating/template/do-get-list`,
  "staff evaluation 360 feedback url": `${utils.api_host}/staff_rating/360_feedback/do-get-list`,
  "staff evaluation 360 deployment url": `${utils.api_host}/staff_rating/360_feedback/do-get-deployment-list`,
  "feedback 360 evaluation user url": `${utils.api_host}/staff_rating/360_evaluation/do-get-list`,
  "search staff rating category": `${utils.api_host}/staff_rating/template/do-search-category/{query}`,
  "api manager dynamic jwt access url": `${utils.api_host}/api_manager/jwt/do-get-list`,
  "api manager dynamic jwt token url": `${utils.api_host}/api_manager/jwt/do-get-token-list`,
  "api manager endpoint monitor url": `${utils.api_host}/api_manager/do-monit-endpoint`,
  "project url": `${utils.api_host}/project/project/do-get-list`,
  "ngine monitor url": `${utils.api_host}/ngine_monitor/monitor/do-get-list`,
  "fel url": `${utils.api_host}/fel_guatemala/billing/do-get-list`,
  "multimoney staff url": `${utils.api_host}/multimoney_staff/admin/do-get-list`,
  "multimoney staff own user url": `${utils.api_host}/multimoney_staff/user/do-get-list`,
  "multimoney staff area url": `${utils.api_host}/multimoney_staff/configuration/area/do-get-list`,
  "multimoney staff country url": `${utils.api_host}/multimoney_staff/configuration/country/do-get-list`,
  "multimoney staff grouper url": `${utils.api_host}/multimoney_staff/configuration/grouper/do-get-list`,
  "multimoney staff job position url": `${utils.api_host}/multimoney_staff/configuration/job_position/do-get-list`,
  "multimoney staff status url": `${utils.api_host}/multimoney_staff/configuration/status/do-get-list`,
  "multimoney staff team url": `${utils.api_host}/multimoney_staff/configuration/team/do-get-list`,
  "search multimoney staff": `${utils.api_host}/multimoney_staff/organization/do-search-staff/{query}`,
  "product category url": `${utils.api_host}/product_category/do-get-list`,
  "automation url": `${utils.api_host}/automation/automation/do-get-list`,
  "automation group url": `${utils.api_host}/automation/group/do-get-list`,
  "automation task url": `${utils.api_host}/automation/task/do-get-list`,
  "search fel emitter": `${utils.api_host}/fel_guatemala/emitter/do-search/{query}`,
  "intercable billing url": `${utils.api_host}/intercable_billing/bill/do-get-list`,
  "course assignation unassigned url": `${utils.api_host}/course/revision/do-get-unassigned`,
};

Vue.config.productionTip = true;

Vue.use(responsive);
Vue.use(VueSession);
Vue.use(VueTruncate);
Vue.use(VueAxios, axios);
Vue.use(VueImg);
Vue.use(VueMask);
Vue.use(VueAlertify, {
  transition: "zoom",
  notifier: {
    delay: 5,
    position: "top-right",
    closeButton: false,
  },
  glossary: {
    title: "Modul Swissknife",
    ok: "OK",
    cancel: "Cancel",
  },
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
``;
